{
  "arbre": "Estructura organizativa",
  "nouDepartament": "Nuevo departamento",
  "cerca": "Buscar departamento, área o servicio…",
  "filtres": {
    "etiqueta": "Tipo de área",
    "tot": "Todo",
    "GUARDIA_IT": "Guardia",
    "CRISI": "Crisis"
  },
  "mostraInactius": "Mostrar inactivos",
  "nNivells_one": "{{count}} nivel",
  "nNivells_other": "{{count}} niveles",
  "compteDep": "{{arees}} · {{serveis}}",
  "senseFiltre": "Ningún área coincide con el filtro.",
  "llegenda": "Tachado = inactivo",
  "afegeixFill": "Añadir {{tipus}} en {{nom}}",
  "plega": "Plegar {{nom}}",
  "desplega": "Desplegar {{nom}}",
  "tipus": {
    "DEPARTAMENT": "departamento",
    "AREA": "área",
    "SERVEI": "servicio"
  },
  "tipusCap": {
    "DEPARTAMENT": "Departamento",
    "AREA": "Área",
    "SERVEI": "Servicio"
  },
  "inactiu": "Inactivo",
  "senseResultats": "Nada coincide con «{{q}}»",
  "buit": "Todavía no hay ningún departamento. Crea el primero.",
  "tria": "Elige un departamento, un área o un servicio del árbol.",
  "organitzacio": "Organización",
  "accions": {
    "desactiva": "Desactivar",
    "reactiva": "Reactivar",
    "mou": "Mover…",
    "nou": {
      "AREA": "Nueva área",
      "SERVEI": "Nuevo servicio"
    }
  },
  "dades": {
    "DEPARTAMENT": "Datos del departamento",
    "AREA": "Datos del área",
    "SERVEI": "Datos del servicio"
  },
  "camps": {
    "nom": "Nombre",
    "codi": "Código",
    "codiAjuda": "Identificador corto y único.",
    "tipusArea": "Tipo de área",
    "descripcio": "Descripción",
    "procediment": "Procedimiento alternativo",
    "procedimentAjuda": "Lo verán quienes reciban el aviso si el servicio no está disponible.",
    "circuit": "Circuito de escalado",
    "circuitDefecte": "Circuito por defecto",
    "veuCircuit": "Ver el circuito",
    "plantilla": "Plantilla de mensaje",
    "sensePlantilla": "Sin plantilla",
    "canals": "Canales por defecto",
    "canalsAjuda": "Canales con los que se avisa por defecto al activar este servicio. Solo se cambian aquí."
  },
  "ajudaTipus": {
    "GUARDIA_IT": "Tiene calendario de guardias y técnico de guardia.",
    "CRISI": "Avisa al comité; la guardia es opcional."
  },
  "fills": {
    "AREA": "Áreas de {{nom}}",
    "SERVEI": "Servicios de {{nom}}"
  },
  "senseFills": {
    "AREA": "Este departamento todavía no tiene áreas.",
    "SERVEI": "Esta área todavía no tiene servicios."
  },
  "nArees_one": "{{count}} área",
  "nArees_other": "{{count}} áreas",
  "nServeis_one": "{{count}} servicio",
  "nServeis_other": "{{count}} servicios",
  "guardia": {
    "titol": "De guardia ahora",
    "calendari": "Calendario",
    "calendaris": "Calendarios",
    "titular": "Titular",
    "suplent": "Suplente",
    "fins": "hasta {{data}}",
    "senseSuplent": "Sin suplente",
    "senseCobertura": "Sin cobertura ahora",
    "ningu": "Nadie de guardia ahora",
    "ninguText": "Los avisos de sus servicios escalarán directamente al siguiente nivel del circuito.",
    "crisi": "Área de crisis: los avisos van al comité. La guardia es opcional y ahora no hay ninguna.",
    "crisiFila": "Área de crisis: sin guardia asignada",
    "cobreix_one": "Cubre el servicio del área",
    "cobreix_other": "Cubre los {{count}} servicios del área",
    "departament": "Guardia del departamento",
    "departamentText": "Recibe los avisos que escalan por encima del área",
    "senseDepartament": "Este departamento no tiene guardia de departamento ahora.",
    "totesCobertes": "Todas las áreas cubiertas",
    "areesSense_one": "{{count}} área sin cobertura",
    "areesSense_other": "{{count}} áreas sin cobertura",
    "area": "Área",
    "senseArees": "Este departamento no tiene áreas.",
    "carregant": "Cargando las guardias…",
    "senseDades": "No se han podido consultar las guardias.",
    "servei": "Guardia del área",
    "serveiText": "El técnico de guardia del área {{area}} cubre este servicio."
  },
  "pestanyes": {
    "etiqueta": "Secciones del servicio",
    "general": "General",
    "avisos": "Avisos",
    "persones": "Personas",
    "documents": "Documentos"
  },
  "experts": {
    "titol": "Expertos",
    "buit": "Este servicio no tiene expertos asignados.",
    "gestiona": "Gestionar",
    "TITULAR": "Titular",
    "SUBSTITUT": "Suplente"
  },
  "documents": {
    "titol": "Documentos del servicio",
    "buit": "Este servicio todavía no tiene documentos.",
    "puja": "Subir un documento para este servicio",
    "biblioteca": "Abrir la biblioteca",
    "versio": "v{{n}}"
  },
  "crea": {
    "etiqueta": {
      "DEPARTAMENT": "Nuevo departamento",
      "AREA": "Nueva área",
      "SERVEI": "Nuevo servicio"
    },
    "titol": {
      "DEPARTAMENT": "Crear un departamento",
      "AREA": "Crear un área",
      "SERVEI": "Crear un servicio"
    },
    "boto": {
      "DEPARTAMENT": "Crear el departamento",
      "AREA": "Crear el área",
      "SERVEI": "Crear el servicio"
    },
    "placeholder": {
      "DEPARTAMENT": "p. ej. Recursos Humanos",
      "AREA": "p. ej. Seguridad informática",
      "SERVEI": "p. ej. Wifi de tiendas"
    },
    "on": "Se creará en:",
    "arrel": "Organización (nivel superior)",
    "codiSuggerit": "Si lo dejas vacío, será {{codi}}. No se podrá cambiar fácilmente.",
    "hereta": "Hereda el tipo {{tipus}} del área. Después podrás asignarle circuito, plantilla y personas en sus pestañas.",
    "cancella": "Cancelar"
  },
  "confirma": {
    "desactivaTitol": "Desactivar «{{nom}}»",
    "reactivaTitol": "Reactivar «{{nom}}»",
    "desactivaText": "Dejará de aparecer al crear activaciones y en los selectores. El historial se conserva y se puede reactivar.",
    "desactivaFills": "Sus elementos seguirán existiendo, pero no se podrán elegir mientras esté inactivo.",
    "reactivaText": "Volverá a estar disponible para nuevas activaciones.",
    "desactiva": "Desactivar",
    "reactiva": "Reactivar"
  },
  "mou": {
    "titol": "Mover «{{nom}}»",
    "etiqueta": "Mover",
    "AREA": "Departamento de destino",
    "SERVEI": "Área de destino",
    "ara": "Ahora está en:",
    "text": "Se moverá con todo lo que contiene. Los roles asignados en el lugar de origen dejarán de aplicarse.",
    "mou": "Mover"
  },
  "informar": {
    "titol": "Personas a informar",
    "resum_one": "{{count}} persona",
    "resum_other": "{{count}} personas",
    "afegeix": "Añadir persona",
    "edita": "Editar",
    "editaPersona": "Editar {{nom}}",
    "editaTitol": "Editar «{{nom}}»",
    "nouTitol": "Nueva persona a informar",
    "etiqueta": "Persona a informar",
    "importa": "Importar Excel",
    "exporta": "Exportar",
    "cerca": "Buscar en la lista…",
    "buit": "Este servicio no tiene personas a informar.",
    "senseCoincidencies": "Nadie de la lista coincide con la búsqueda.",
    "senseCompte": "Sin cuenta",
    "senseCompteAjuda": "No tiene cuenta corporativa: solo recibe avisos por los canales con teléfono o correo.",
    "treu": "Quitar",
    "treuPersona": "Quitar a {{nom}}",
    "treuTitol": "Quitar a «{{nom}}» de la lista",
    "treuText": "Dejará de recibir los avisos de este servicio.",
    "correuInvalid": "Hace falta un correo electrónico válido.",
    "canalsBuit": "Elige al menos un canal.",
    "origenEntra": "Los datos vienen de Entra ID: aquí solo puedes cambiar los canales.",
    "origenUsuari": "Es un usuario de la aplicación: aquí solo puedes cambiar los canales.",
    "usuari": "Usuario",
    "cercaUsuari": "Busca un usuario por nombre o correo",
    "cercaUsuariAjuda": "Escribe al menos 2 letras para buscar entre los usuarios de la aplicación.",
    "senseUsuaris": "Ningún usuario coincide con la búsqueda.",
    "canviaUsuari": "Cambiar",
    "desa": "Guardar",
    "crea": "Añadir a la lista",
    "nom": "Nombre",
    "contacte": "Contacto",
    "email": "Correo electrónico",
    "telefon": "Teléfono",
    "canals": "Canales",
    "origen": "Origen",
    "origens": {
      "MANUAL": "Manual",
      "ENTRA": "Entra ID",
      "EXCEL": "Excel"
    }
  }
}
